import { render } from "./index.vue?vue&type=template&id=e6cecb56&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=e6cecb56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e6cecb56"

export default script